<template>
    <div class="page" data-page="chat">
        <div class="pure-g chatArea">

            <!--Mobile Nav-->
            <div class="pure-u-1 mobileChatNavArea">
                <div>
                    <nav>
                        <a href="#0" :class="{ active: window.mobileNavItem === 'chats' }" @click.prevent="window.mobileNavItem = 'chats'">
                            <ion-icon name="people"></ion-icon>
                        </a>
                        <a href="#0" :class="{ active: window.mobileNavItem === 'chat' }" @click.prevent="window.mobileNavItem = 'chat'">
                            <ion-icon name="chatbubbles"></ion-icon>
                        </a>
                        <a href="#0" :class="{ active: window.mobileNavItem === 'info' }" @click.prevent="window.mobileNavItem = 'info'">
                            <ion-icon name="information-circle"></ion-icon>
                        </a>
                    </nav>
                </div>
            </div>

            <!--People or Chats Area-->
            <div class="pure-u-1 pure-u-lg-5-24 left leftArea" :style="`height:${window.height}px;`" :class="{ active: window.mobileNavItem === 'chats' }">
                
                <div class="top">
                    <nav class="chatOrPeople">
                        <a
                            href="#0"
                            @click.prevent="toggleChat('People')"
                            :class="{active: chatsOrPeople === 'People'}"
                        >People</a>
                        <a
                            href="#0"
                            @click.prevent="toggleChat('Chats')"
                            :class="{active: chatsOrPeople === 'Chats'}"
                        >Chats</a>
                    </nav>
                    <a
                        href="#0"
                        @click.prevent="toggleChat('Create')"
                        :class="{active: chatsOrPeople === 'Create'}"
                        class="btn secondary icon-left createNewBtn"
                    >
                        <ion-icon name="pencil"></ion-icon> Create Chat
                    </a>

                    <input
                        v-if="chatsOrPeople === 'Chats'"
                        type="text"
                        v-model="searchInput"
                        :placeholder="'Search Chats'"
                        autocomplete="false"
                        autocorrect="off"
                        spellcheck="false"
                    />
                    <input
                        v-else-if="chatsOrPeople === 'People'"
                        type="text"
                        v-model="searchPeople"
                        :placeholder="'Search People'"
                        autocomplete="false"
                        autocorrect="off"
                        spellcheck="false"
                    />
                </div>

                <!--Online Users-->
                <div v-if="searchInput === '' && searchPeople === ''" class="onlineUsersArea">
                    <OnlineUsers
                        @open-chat="(UserItem) => {
                            openChat(UserItem, 'person')
                        }"
                    ></OnlineUsers>
                </div>

                <!--Chats List-->
                <div v-if="chatsOrPeople === 'Chats'" class="chatsList" :class="{ full: room.messages === null }">
                    <ChatsList
                        :roomId="room.id"
                        :searchInput="searchInput"
                        @open-chat="(chatItem) => {
                            openChat(chatItem, 'chat')
                        }"
                    ></ChatsList>
                </div>

                <!--People List-->
                <div v-if="chatsOrPeople === 'People'" class="chatsList" :class="{ full: room.messages === null }">
                    <template v-if="filteredPeople.length > 0">
                        <div
                            v-for="(userItem, index) in filteredPeople"
                            :key="index"
                            class="person"
                            :class="{
                                active: isChatActive(userItem)
                            }"
                            @click.prevent="openChat(userItem, 'person')"
                            v-show="userItem.uid !== user.uid"
                        >
                            <div class="avatar medium" :style="'background-image:url('+ userItem.photoURL +');'">
                                <MemberStatus :key="`people_list_member_${userItem.uid}`" :memberId="userItem.uid"></MemberStatus>
                            </div>
                            <div class="chatInfo">
                                <p class="chatName">{{ userItem.displayName }}</p>
                                <p>
                                    <span v-if="userItem.displayName === 'Anand Davaasuren'" class="badge staff">Organizer</span>
                                    <span v-else-if="userItem.isStaff" class="badge staff">{{ userItem.staffTitle }}</span>
                                    <span v-else-if="userItem.isMember" class="badge yellow">Member</span>
                                    <span v-else class="badge grey">User</span>

                                    <template v-if="userHasLocation(userItem)">
                                        <span class="badge grey hint hint--top" :data-hint="userItem.location.country.sortname + ' - ' + userItem.location.state.name">
                                            {{ userItem.location.city.name }}
                                        </span>
                                    </template>
                                </p>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div v-if="searchInput === ''" class="empty large">
                            <div>
                                <ion-icon name="information-circle"></ion-icon>
                                <p>No people here yet.</p>
                            </div>
                        </div>
                        <div v-else class="empty">
                            <div>
                                <ion-icon name="search"></ion-icon>
                                <p>No person found.</p>
                            </div>
                        </div>
                    </template>
                </div>

                <!--Create List-->
                <div v-if="chatsOrPeople === 'Create'" class="chatsList" :class="{ full: room.messages === null }" :key="createKey">
                    
                    <div class="info">
                        <span class="smallLabel">New message to: </span>

                        <input
                            v-if="chatsOrPeople === 'Create'"
                            type="text"
                            v-model="searchPeople"
                            :placeholder="'Search people'"
                            autocomplete="false"
                            autocorrect="off"
                            spellcheck="false"
                        />

                        <!--Selected People-->
                        <template v-if="createRoom.peopleObj !== null">
                            
                            <div
                                v-for="(person, index) in createRoom.peopleObj"
                                :key="index"
                                class="personItem"
                            >
                                <div class="avatar small" :style="'background-image:url('+ person.photoURL +');'">
                                    <MemberStatus :memberId="person.uid"></MemberStatus>
                                </div>
                                <p class="personName">{{ person.displayName }}</p>
                                <div class="actions">
                                    <a v-if="person.uid !== $store.state.currentUser.uid" href="#0" class="actionBtn remove" @click.prevent="removePerson(person.uid, 'tempRoom')">
                                        <ion-icon name="remove-circle"></ion-icon>
                                    </a>
                                </div>
                            </div>

                            <a
                                v-if="!(Object.keys(createRoom.peopleObj).length === 1 && typeof createRoom.peopleObj[$store.state.currentUser.uid] !== 'undefined')"
                                href="#0"
                                @click.prevent="createChat"
                                class="btn green icon-left createChatBtn"
                            >
                                <ion-icon name="pencil"></ion-icon>
                                Create <template v-if="Object.keys(createRoom.peopleObj).length > 2">group </template>chat
                            </a>
                        </template>
                    </div>

                    <!--All Non Selected People-->
                    <template v-if="filteredPeople.length > 0">
                        <template v-for="userItem in filteredPeople">
                            <div
                                :key="`person_select_${userItem.uid}`"
                                class="personItem"
                                :class="{ active: isChatActive(userItem) }"
                                @click.prevent="selectPerson(userItem)"
                                v-show="!checkIfUserSelected(userItem) && searchPeople !== ''"
                            >
                                <div class="avatar small" :style="'background-image:url('+ userItem.photoURL +');'">
                                    <MemberStatus :memberId="userItem.uid"></MemberStatus>
                                </div>
                                <p class="personName">{{ userItem.displayName }}</p>
                                <div class="actions">
                                    <a href="#0" v-if="!checkIfUserSelected(userItem)" class="actionBtn add" @click.prevent="selectPerson(userItem)">
                                        <ion-icon name="add-circle"></ion-icon>
                                    </a>
                                    <a href="#0" v-else class="actionBtn remove" @click.prevent="removePerson(userItem.uid)">
                                        <ion-icon name="remove-circle"></ion-icon>
                                    </a>
                                </div>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <div v-if="searchPeople === ''" class="empty large">
                            <div>
                                <ion-icon name="information-circle"></ion-icon>
                                <p>No people here yet.</p>
                            </div>
                        </div>
                        <div v-else class="empty">
                            <div>
                                <ion-icon name="search"></ion-icon>
                                <p>No person found.</p>
                            </div>
                        </div>
                    </template>
                </div>

            </div>
            
            <!--Message Area-->
            <div class="pure-u-1 pure-u-lg-14-24 center centerArea" :style="`height:${window.height}px;`" :class="{ active: window.mobileNavItem === 'chat' }">

                <!-- <div class="messageTitle">
                    <p class="om-label">{{ room.title }}</p>
                </div> -->
                
                <!--Messages-->
                <div
                    ref="messageScrollArea"
                    class="messageArea"
                    @scroll="handleScroll($event)"
                    @drop.prevent="addFiles"
                    @dragover.prevent="dragOver"
                    @dragleave.prevent="dragLeave"
                    :class="{
                        empty: room.messages === null,
                        highlight: dragAreaActive
                    }"
                >
                    <template v-if="loading">
                        <div class="empty large loadingState">
                            <div>
                                <div class="loading no-margin"></div>
                                <p>Loading chat room...</p>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="room.messages !== null">
                        
                        <!--Default User Info-->
                        <div
                            class="messageDefaultUser"
                            :class="{ multiple: room.details.roomType === 'group' }"
                        >
                            <div>
                                <template v-for="person in room.details.peopleObj">
                                    <div :key="`user_${person.uid}`" v-if="person.uid !== user.uid" class="defaultUser">
                                        <div class="avatar medium" :style="`background-image:url(${$store.state.allUsers[person.uid].photoURL});`"></div>
                                    </div>
                                </template>
                                <p class="name bold">{{ room.title }}</p>
                            </div>
                        </div>

                        <div
                            v-for="(message, index) in room.messages"
                            :key="index"
                            class="message"
                            :class="{
                                right: message.uid === user.uid
                            }"
                        >
                            <!--Date & Time-->
                            <div v-if="message.showMessageTime" class="messageDateDivider">
                                <p class="messageDate">{{ message.timestamp | messageTime }}</p>
                            </div>

                            <div class="messageInner">
                                <div class="messageMsgInner">

                                    <!--Avatar-->
                                    <div v-if="message.uid !== user.uid" class="messageAvatar">
                                        <div>
                                            <div class="avatar small" :style="'background-image:url('+ $store.state.allUsers[message.uid].photoURL +');'"></div>
                                        </div>
                                    </div>

                                    <!--Actions Left-->
                                    <span v-if="message.uid === user.uid && message.type !== 'deleted'" class="messageActions">
                                        <a
                                            href="#0"
                                            class="iconBtn hint hint--top"
                                            data-hint="Like message"
                                            @click.prevent="likeMessage(message, 'like')"
                                        >
                                            <ion-icon name="thumbs-up"></ion-icon>
                                        </a>

                                        <!--More Menu-->
                                        <details class="dropdown details-reset details-overlay d-inline-block moreMenu">
                                            <summary class="d-inline" aria-haspopup="true">
                                                <a class="iconBtn hint hint--top" data-hint="More">
                                                    <ion-icon name="ellipsis-horizontal"></ion-icon>
                                                </a>
                                            </summary>
                                            <ul class="dropdown-menu dropdown-menu-s">
                                                <li>
                                                    <a href="#0" class="dropdown-item" @click.prevent="copyMessage(message)">
                                                        <ion-icon name="documents"></ion-icon> Copy
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#0" class="dropdown-item" @click.prevent="forwardMessage(message)">
                                                        <ion-icon name="arrow-redo"></ion-icon> Forward
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#0" class="dropdown-item" @click.prevent="deleteMessage(index)">
                                                        <ion-icon name="trash"></ion-icon> Delete
                                                    </a>
                                                </li>
                                            </ul>
                                        </details>
                                    </span>

                                    <!--Main Message-->
                                    <span
                                        class="messageWrapper"
                                        :class="{
                                            long: message.message.length > 40,
                                            emoji: message.type === 'system-emoji' || message.type === 'custom-emoji',
                                            gif: message.type === 'gif',
                                            sticker: message.type === 'sticker',
                                            image: message.type === 'image-single' || message.type === 'image-multiple',
                                            deleted: message.type === 'deleted'
                                        }"
                                    >
                                        <!--Removed-->
                                        <template v-if="message.type === 'deleted'">
                                            <span>Message has been removed.</span>
                                        </template>

                                        <!--Text-->
                                        <template v-else-if="message.type === 'text' || message.type === 'system-emoji' || message.type === 'custom-emoji'">
                                            {{ message.message }}
                                        </template>

                                        <!--Gif / Sticker-->
                                        <template v-else-if="message.type === 'gif' || message.type === 'sticker'">
                                            <img :src="message.url" class="gifItem" />
                                        </template>

                                        <!--Images / Videos-->
                                        <template v-else-if="message.type === 'image-single' || message.type === 'image-multiple'">
                                            <template v-for="(file, index) in message.urls">
                                                <template v-if="file.type === 'image'">
                                                    <img
                                                        :key="index"
                                                        :src="file.small.url"
                                                        class="imageMessage"
                                                        :class="message.type"
                                                        @click.prevent="showLightBoxItemById(file.uid)"
                                                    />
                                                </template>
                                                <template v-else-if="file.type === 'video'">
                                                    <video
                                                        :key="index"
                                                        :src="file.url"
                                                        muted
                                                        controls
                                                        class="videoMessage"
                                                        @click.prevent="showLightBoxItemById(file.uid)"
                                                    ></video>
                                                </template>
                                            </template>
                                        </template>

                                        <!--Reactions -->
                                        <span 
                                            v-if="hasReactions(message)"
                                            class="messageReactions"
                                        >
                                            <div class="Popover">
                                                <div
                                                    class="Popover-message Box"
                                                    :class="{
                                                        'Popover-message--bottom-right': message.uid === user.uid,
                                                        'Popover-message--bottom-left': message.uid !== user.uid
                                                    }"
                                                    v-html="getMessageReactionsHint(message.reactions)"
                                                ></div>
                                                <span class="reactionEmojis">
                                                    <template v-if="hasReactionLikes(message)">
                                                        <span class="reactionEmoji">
                                                            <ion-icon name="thumbs-up"></ion-icon>
                                                            <span v-if="Object.keys(message.reactions.likes).length > 1" class="emojiCount">
                                                                {{ Object.keys(message.reactions.likes).length }}
                                                            </span>
                                                        </span>
                                                    </template>
                                                </span>
                                            </div>
                                        </span>
                                    </span>

                                    <!--Actions Right-->
                                    <span v-if="message.uid !== user.uid && message.type !== 'deleted'" class="messageActions">
                                        
                                        <!--More Menu-->
                                        <details class="dropdown details-reset details-overlay d-inline-block moreMenu">
                                            <summary class="d-inline" aria-haspopup="true">
                                                <a class="iconBtn hint hint--top" data-hint="More">
                                                    <ion-icon name="ellipsis-horizontal"></ion-icon>
                                                </a>
                                            </summary>
                                            <ul class="dropdown-menu dropdown-menu-s">
                                                <li>
                                                    <a href="#0" class="dropdown-item" @click.prevent="copyMessage(message)">
                                                        <ion-icon name="documents"></ion-icon> Copy
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#0" class="dropdown-item" @click.prevent="forwardMessage(message)">
                                                        <ion-icon name="arrow-redo"></ion-icon> Forward
                                                    </a>
                                                </li>
                                                <li v-if="message.uid === user.uid">
                                                    <a href="#0" class="dropdown-item" @click.prevent="deleteMessage(message)">
                                                        <ion-icon name="trash"></ion-icon> Delete
                                                    </a>
                                                </li>
                                            </ul>
                                        </details>

                                        <a
                                            href="#0"
                                            class="iconBtn hint hint--top"
                                            data-hint="Like message"
                                            @click.prevent="likeMessage(message, 'like')"
                                        >
                                            <ion-icon name="thumbs-up"></ion-icon>
                                        </a>
                                    </span>

                                    <!--Seen-->
                                    <div v-if="message.seen !== null" class="messageSeen" :class="room.roomType">
                                        <div>
                                            <template v-for="(person, personUid) in message.seen">
                                                <template v-if="personUid !== user.uid && room.details.peopleObj[personUid].lastMessageId === message.messageId">
                                                    <div :key="personUid" class="avatar small" :style="'background-image:url('+ $store.state.allUsers[personUid].photoURL +');'"></div>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="empty large">
                            <div>
                                <ion-icon name="information-circle"></ion-icon>
                                <p>Select chat or a person from the list first.</p>
                            </div>
                        </div>
                    </template>
                </div>

                <!--Input Actions-->
                <div v-if="room.messages !== null && !loading" class="messageInput">

                    <!--Scroll to bottom-->
                    <div v-if="showScrollToBottom" class="scrollToBottomArea">
                        <a @click.prevent="messageAreaScroll" href="#0" class="scrollToBottomBtn">
                            <ion-icon name="arrow-down"></ion-icon>
                        </a>
                    </div>

                    <div v-if="filesLoading" class="progressBarArea">
                        <p>Uploading files... <span class="loading small dark"></span></p>
                    </div>

                    <!--Pickers-->
                    <div
                        v-if="showEmojiPicker"
                        class="emojiPickerWrapper"
                        @click.prevent="showEmojiPicker = true"
                    >
                        <picker
                            :data="emojiIndex"
                            :emoji="'grinning'"
                            :emojiTooltip="false"
                            class="emojiPicker"
                            title="OneMgl"
                            set="facebook"
                            @select="selectEmoji"
                            :autoFocus="true"
                        />
                    </div>
                    <div v-if="showGifPicker" class="pickerWrapper gifPicker">
                        <GifSearch
                            :placeholder="'Search for a GIF'"
                            @onSelected="gifSelected"
                        ></GifSearch>
                    </div>
                    <div v-if="showStickerPicker" class="pickerWrapper stickerPicker">
                        <StickerSearch
                            :placeholder="'Search for a Sticker'"
                            @onSelected="stickerSelected"
                            version="v1"
                        ></StickerSearch>
                    </div>

                    <div class="inputWrapper">
                        <input
                            ref="messageInput"
                            v-model="messageInput"
                            type="text"
                            placeholder="Enter message here"
                            class="input"
                            @keydown.enter="sendMessage"
                            autocomplete="false"
                        />

                        <!--Input Actions-->
                        <div class="inputActionBtns">
                            <div>
                                <a
                                    href="#0"
                                    @click.prevent="sendMessage"
                                    class="actionIconBtn sendBtn"
                                >
                                    <ion-icon name="send"></ion-icon>
                                </a>
                                <a
                                    href="#0"
                                    @click.prevent="toggleEmojiPicker"
                                    class="actionIconBtn emojiPickerTrigger hint hint--top"
                                    data-hint="Emoji"
                                    tabindex="0"
                                >
                                    <ion-icon v-show="!showEmojiPicker" name="happy"></ion-icon>
                                    <ion-icon v-show="showEmojiPicker" name="close"></ion-icon>
                                </a>
                                <a
                                    href="#0"
                                    @click.prevent="toggleGifPicker"
                                    class="actionIconBtn gifPickerTrigger hint hint--top"
                                    data-hint="GIF"
                                    tabindex="0"
                                >
                                    <svg v-show="!showGifPicker" class="iconBtnSvg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <title>Gif</title>
                                        <g>
                                            <path d="M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z"></path>
                                        </g>
                                    </svg>
                                    <ion-icon v-show="showGifPicker" name="close"></ion-icon>
                                </a>
                                <a
                                    href="#0"
                                    class="actionIconBtn stickersTrigger hint hint--top"
                                    data-hint="Stickers"
                                    @click.prevent="toggleStickerPicker"
                                    tabindex="0"
                                >
                                    <svg v-show="!showStickerPicker" class="iconBtnSvg stickerIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <title>Stickers</title>
                                        <g>
                                            <path class="path1" d="M8,22A14.015,14.015,0,0,1,22,8a12.951,12.951,0,0,1,1.329.08A11.993,11.993,0,1,0,8.081,23.329,13.012,13.012,0,0,1,8,22Z"></path>
                                            <path d="M22,10A11.92,11.92,0,0,0,10.156,23.844L23.844,10.156A12.051,12.051,0,0,0,22,10Z"></path>
                                        </g>
                                    </svg>
                                    <ion-icon v-show="showStickerPicker" name="close"></ion-icon>
                                </a>
                                <a 
                                    href="#0"
                                    class="actionIconBtn fileUploadBtn hint hint--top"
                                    data-hint="Upload file"
                                    tabindex="0"
                                    @click.prevent="$refs.fileUploadInput.click()"
                                >
                                    <ion-icon name="images"></ion-icon>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--Chat Details-->
            <div class="pure-u-1 pure-u-lg-5-24 right rightArea" :style="`height:${window.height}px;`" :class="{ active: window.mobileNavItem === 'info' }">
                
                <!-- <p class="om-label">Details</p> -->

                <template v-if="room.details !== null">

                    <div class="info">
                        <span class="smallLabel">People ({{ Object.keys(room.details.peopleObj).length }}): </span>

                        <div
                            v-for="(person, index) in room.details.peopleObj"
                            :key="index"
                            class="personItem"
                        >
                            <div class="avatar small" :style="'background-image:url('+ person.photoURL +');'">
                                <MemberStatus :memberId="person.uid"></MemberStatus>
                            </div>
                            <p class="personName">
                                {{ person.displayName }}

                                <template v-if="isRoomAdmin(person)">
                                    <span class="adminIcon hint hint--top" data-hint="Admin">
                                        <ion-icon name="ribbon"></ion-icon>
                                    </span>
                                </template>
                            </p>

                            <div v-if="Object.keys(room.details.peopleObj).length > 2" class="actions">
                                <a href="#0" class="actionBtn remove" @click.prevent="removePerson(person.uid, 'chatRoom')">
                                    <ion-icon name="remove-circle"></ion-icon>
                                </a>
                            </div>
                        </div>

                        <!--Add Person to Chat-->
                        <div class="addPersonWrapper" :class="{ active: addPersonActive }">
                            <a
                                v-if="Object.keys(room.details.peopleObj).length > 2"
                                href="#0"
                                class="btn secondary addPersonBtn"
                                :class="{
                                    iconBtn: addPersonActive,
                                    'icon-left': !addPersonActive,
                                    closeBtn: addPersonActive
                                }"
                                @click.prevent="toggleAddPerson"
                            >
                                <ion-icon v-if="!addPersonActive" name="person-add"></ion-icon>
                                <span v-if="!addPersonActive">Add Person</span>
                                <ion-icon v-if="addPersonActive" name="close"></ion-icon>
                            </a>
                            <a
                                v-else
                                href="#0"
                                class="btn secondary icon-left addPersonBtn"
                                @click.prevent="createGroupChat"
                            >
                                <ion-icon name="person-add"></ion-icon>
                                <span>Create Group Chat</span>
                            </a>

                            <p v-if="addPersonActive" class="om-label">Select Person to Add</p>

                            <input
                                v-if="addPersonActive"
                                type="text"
                                v-model="searchPeople"
                                :placeholder="'Search people'"
                                autocomplete="false"
                                autocorrect="off"
                                spellcheck="false"
                            />

                            <div v-if="addPersonActive" class="addPersonScroll">
                                <template v-if="filteredPeople.length > 0">
                                    <div
                                        v-for="(userItem, index) in filteredPeople"
                                        :key="index"
                                        class="personItem"
                                        :class="{ active: isChatActive(userItem) }"
                                        v-show="userItem.uid !== user.uid && searchPeople !== ''"
                                    >
                                        <template v-if="typeof room.details.peopleObj[userItem.uid] === 'undefined'">
                                            <div class="avatar small" :style="'background-image:url('+ userItem.photoURL +');'">
                                                <MemberStatus :memberId="userItem.uid"></MemberStatus>
                                            </div>
                                            <p class="personName">{{ userItem.displayName }}</p>
                                            <div class="actions">
                                                <a href="#0" v-if="!checkIfUserSelected(userItem)" class="actionBtn add" @click.prevent="selectPerson(userItem, 'chatRoom')">
                                                    <ion-icon name="add-circle"></ion-icon>
                                                </a>
                                                <a href="#0" v-else class="actionBtn remove" @click.prevent="removePerson(userItem.uid, 'chatRoom')">
                                                    <ion-icon name="remove-circle"></ion-icon>
                                                </a>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                                <template v-else>
                                    <div v-if="searchPeople === ''" class="empty large">
                                        <div>
                                            <ion-icon name="information-circle"></ion-icon>
                                            <p>No people here yet.</p>
                                        </div>
                                    </div>
                                    <div v-else class="empty">
                                        <div>
                                            <ion-icon name="search"></ion-icon>
                                            <p>No person found.</p>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>

                    <div class="info">
                        <span class="smallLabel">Created on: </span>
                        {{ room.details.createdOn | createdOn }}
                    </div>

                    <div class="info actions">
                        <span class="smallLabel">Actions: </span>
                        <a
                            href="#0"
                            @click.prevent="deleteChat"
                            class="btn secondary iconBtn"
                        >
                            <ion-icon name="trash"></ion-icon>
                        </a>
                    </div>

                    <div class="info">
                        <span class="smallLabel">Files: </span>

                        <a 
                            href="#0"
                            @click.prevent="$refs.fileUploadInput.click()"
                            class="btn secondary icon-left"
                        >
                            <ion-icon v-if="!filesLoading" name="cloud-upload"></ion-icon>
                            <div v-else class="loading small"></div>
                            Upload File(s)
                        </a>
                        <input type="file" ref="fileUploadInput" multiple="multiple" class="fileUploadInput hidden" @change="addFilesFromInput" v-show="false" />
                        <FileUpload
                            :key="`file_uploader_${fileUploaderKey}`"
                            ref="fileUpload"
                            :path="`files/`"
                            :hide="true"
                            :roomId="room.id"
                            :uid="$store.state.currentUser.uid"
                            @upload-success="syncAllUploadedFiles"
                            @delete-success="removedFile"
                        ></FileUpload>

                        <!--Files-->
                        <div v-if="roomFiles.length > 0" class="pure-g files gallery">
                            <div
                                v-for="(file, fileIndex) in roomFiles"
                                :key="`file_${fileIndex}`"
                                class="pure-u-1-3 file"
                            >
                                <template v-if="file.type === 'video'">
                                    <div
                                        class="galleryItem fileItem video image"
                                        :style="`background-image:url(${file.poster.url});`"
                                        @click.prevent="showLightBoxItemById(file.id)"
                                    >
                                        <!-- <video :src="`${file.url}`"></video> -->
                                        <a @click.prevent="$refs.fileUpload.deleteFiles(file)" class="iconBtnCircle"><ion-icon name="trash"></ion-icon></a>
                                    </div>
                                </template>

                                <template v-else-if="file.type === 'image'">
                                    <div
                                        class="galleryItem fileItem image"
                                        :style="`background-image:url(${file.medium.url});`"
                                        @click.prevent="showLightBoxItemById(file.id)"
                                    >
                                        <a @click.prevent="$refs.fileUpload.deleteFiles(file)" class="iconBtnCircle"><ion-icon name="trash"></ion-icon></a>
                                    </div>
                                </template>

                                <template v-else-if="file.type === 'other'">
                                    <div class="fileItem other">
                                        <ion-icon name="document"></ion-icon>
                                        <a @click.prevent="$refs.fileUpload.deleteFiles(file)" class="iconBtnCircle"><ion-icon name="trash"></ion-icon></a>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <!--Lightbox-->
                        <div v-if="roomFiles.length > 0" class="gallery-lightbox">
                            <LightBox
                                ref="files"
                                :media="lightboxFiles"
                                :showLightBox="true"
                                :startAt="showImageAt"
                                v-if="showLightBox"
                                @onClosed="showLightBox = false"
                            >
                                <template slot="close">
                                    <ion-icon name="close"></ion-icon>
                                </template>
                                <template slot="previous">
                                    <ion-icon name="arrow-back"></ion-icon>
                                </template>
                                <template slot="next">
                                    <ion-icon name="arrow-forward"></ion-icon>
                                </template>
                            </LightBox>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="empty large">
                        <div>
                            <ion-icon name="information-circle"></ion-icon>
                            <p>No chat details here yet.</p>
                        </div>
                    </div>
                </template>
            </div>

        </div>
    </div>
</template>

<script>
import moment from 'moment'
const fb = require('@/firebaseConfig.js')
import data from 'emoji-mart-vue-fast/data/all.json'
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast'
import 'emoji-mart-vue-fast/css/emoji-mart.css'
import GifSearch from '@/components/GifSearch'
import StickerSearch from '@/components/StickerSearch'

import FileUpload from '@/components/uploader/FileUpload'
import LightBox from 'vue-image-lightbox'
import MemberStatus from '@/components/MemberStatus'
import ChatsList from '@/components/chat/ChatsList'
import OnlineUsers from '@/components/chat/OnlineUsers'

export default {
    name: 'Chat',

    components: {
        Picker,
        GifSearch,
        StickerSearch,
        MemberStatus,
        ChatsList,
        OnlineUsers,
        FileUpload,
        LightBox
    },

    data(){
        return{
            window: {
                height: 800,
                isDesktop: true,
                mobileNavItem: 'chats'
            },
            chatsOrPeople: 'Chats',
            chatsList: [],
            allUsers: {},
            peopleList: [],
            loading: false,
            room: {
                id: null,
                photoURL: null,
                title: 'Chat',
                messages: null,
                details: null,
                isNew: true,
                files: []
            },
            roomFiles: [],
            createRoom: {
                peopleObj: null
            },
            messageInput: '',
            user: {
                uid: null,
                photo: null,
                name: null
            },
            searchInput: '',
            searchPeople: '',
            dragAreaActive: false,
            showEmojiPicker: false,
            showGifPicker: false,
            showScrollToBottom: false,
            showStickerPicker: false,
            emojiIndex: new EmojiIndex(data),
            createKey: 0,
            addPersonActive: false,
            fileUploaderKey: 0,
            filesLoading: false,
            showImageAt: 0,
            showLightBox: false
        }
    },

    computed: {
        userProfile(){
            return this.$store.state.userProfile
        },
        filteredPeople() {
            return this.peopleList.filter(item => {
                return item.displayName.toLowerCase().indexOf(this.searchPeople.toLowerCase()) > -1
            })
        },
        filteredChats() {
            if(this.addPersonActive){
                return this.chatsList
            }else{
                return this.chatsList.filter(item => {
                    return item.name.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1
                })
            }
        },
        lightboxFiles(){
            let galleryItems = []

            for(let i = 0; i < this.roomFiles.length; i++){
                let file = this.roomFiles[i]

                if(file.type === 'image'){
                    galleryItems.push({
                        id: file.uid,
                        index: i,
                        thumb: file.small.url,
                        src: file.original.url,
                        caption: file.name,
                        provider: 'OneMgl'
                    })
                }else if(file.type === 'video'){
                    galleryItems.push({
                        id: file.uid,
                        index: i,
                        thumb: file.poster.url,
                        sources: [{
                            src: file.url,
                            type: file.fileType
                        }],
                        caption: file.name,
                        provider: 'OneMgl',
                        type: 'video',
                        width: '100%',
                        height: 650,
                        autoplay: true
                    })
                }
            }

            console.log('Lightbox files: ', galleryItems)

            return galleryItems
        },
    },
    
    mounted(){
        this.setWindowSize()
        window.onresize = (event) => {
            this.setWindowSize()
        }

        if(this.$store.state.currentUser !== null){
            this.user.uid = this.$store.state.currentUser.uid
            this.user.photo = this.$store.state.currentUser.photoURL
            this.user.name = this.$store.state.currentUser.displayName

            // this.getAllUsers()

            if(this.$store.state.allUsersNew !== null){
                this.allUsers = this.$store.state.allUsers
                this.peopleList = this.$store.state.allUsersNew
            }

            // Open Chat by User Id
            if(this.$route.query.user){
                let userUid = this.$route.query.user
                let userData = this.$store.state.allUsers[userUid]
                this.openChat(userData, 'person')

                window.history.pushState('chat', 'Chat', '/chat')
            }
        }
    },

    methods: {
        // Users
        async getAllUsers(){

            console.log('All Users from Store: ', this.$store.state.allUsersNew, this.$store.state.allUsers)

            if(this.$store.state.allUsersNew === null || this.$store.state.allUsersNew.length === 0){

                await fb.usersCollection
                    .get()
                    .then(snap => {
                        let usersList = []

                        snap.forEach(user => {
                            let userData = user.data()
                            usersList.push(userData)
                            this.allUsers[userData.uid] = userData
                        })
                        
                        usersList = usersList.sort((a, b) => {
                            let textA = a.displayName.toUpperCase()
                            let textB = b.displayName.toUpperCase()
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
                        })

                        this.peopleList = usersList

                    }).then(() => {

                        // this.getAllChats()
                        
                    }).catch(err => {
                        console.log('Error getting all users: ', err.message)
                    })
            }else{

                let allUsers = this.$store.state.allUsersNew
                let usersList = []

                for(let i = 0; i < allUsers.length; i++){
                    let userData = {}
                    userData = allUsers[i]
                    usersList.push(userData)
                    this.allUsers[userData.uid] = userData
                }
                
                usersList = usersList.sort((a, b) => {
                    let textA = a.displayName.toUpperCase()
                    let textB = b.displayName.toUpperCase()
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
                })

                this.peopleList = usersList

                // this.getAllChats()
            }
        },

        // Chats
        getAllChats(){
            let chatsRef = fb.rdb.ref('users/'+ this.user.uid + '/chats')

            chatsRef.on('value', snap => {
                let data = snap.val()
                if(data !== null){

                    console.log('Get chat: ', data)

                    let chats = []

                    Object.keys(data).forEach(async(key) => {

                        // if(data[key].active === false) return

                        let rawData = await this.getChatInfoData(key)

                        // console.log('Chat raw data: ', rawData)

                        let lastMessageUserName = 'You'
                        let currentTimestamp = moment()
                        let lastMessageId = rawData.chatInfoData.lastMessageId
                        let lastMessageTimestamp = rawData.messages[lastMessageId].timestamp
                        let lastMessageUserTimestamp = moment(lastMessageTimestamp).local()
                        let diff = moment.duration(currentTimestamp.diff(lastMessageUserTimestamp))
                        let lastMessageTime = lastMessageUserTimestamp.format('MMM D')
                        let lastMessage = rawData.messages[lastMessageId].message

                        if(rawData.messages[lastMessageId].type === 'gif'){
                            lastMessage = 'Sent a Gif'
                        }
                        if(rawData.messages[lastMessageId].type === 'sticker'){
                            lastMessage = 'Sent a Sticker'
                        }
                        if(rawData.messages[lastMessageId].type === 'image-single'){
                            lastMessage = 'Sent an Image'
                        }
                        if(rawData.messages[lastMessageId].type === 'image-multiple'){
                            lastMessage = 'Sent '+ rawData.messages[lastMessageId].total +' Images'
                        }
                        if(rawData.messages[lastMessageId].type === 'deleted'){
                            lastMessage = 'Removed a message'
                        }

                        if(rawData.messages[lastMessageId].uid !== this.user.uid){
                            lastMessageUserName = this.$store.state.allUsers[rawData.messages[lastMessageId].uid].firstName
                        }
                        if(diff.asDays() <= 7){
                            lastMessageTime = lastMessageUserTimestamp.format('ddd')
                        }
                        if(diff.asHours() <= 24){
                            lastMessageTime = lastMessageUserTimestamp.format('h:mm a')
                        }

                        let chatObj = {
                            id: key,
                            lastMessageId: lastMessageId,
                            lastMessage: lastMessage,
                            lastMessageUserName: lastMessageUserName,
                            lastMessageTime: lastMessageTime,
                            lastMessageTimestamp: lastMessageTimestamp,
                            info: rawData.chatInfoData,
                            user: null,
                            roomType: 'single',
                            name: '',
                            peopleObj: {},
                            people: rawData.chatInfoData.people,
                            peopleArr: [],
                            status: data[key].active
                        }
                        let peopleCount = 0
                        
                        Object.keys(rawData.chatInfoData.people).forEach(personKey => {

                            let userObj = {
                                uid: this.$store.state.allUsers[personKey].uid,
                                displayName: this.$store.state.allUsers[personKey].displayName,
                                firstName: this.$store.state.allUsers[personKey].firstName,
                                photoURL: this.$store.state.allUsers[personKey].photoURL
                            }

                            if(this.user.uid !== personKey){
                                peopleCount += 1

                                if(chatObj.name !== ''){
                                    chatObj.name += ', '
                                }
                                if(Object.keys(rawData.chatInfoData.people).length > 2){
                                    chatObj.name += userObj.firstName
                                }else{
                                    chatObj.name = userObj.displayName
                                }

                                chatObj.peopleObj[personKey] = userObj
                            }

                            chatObj.peopleArr.push(userObj)
                        })

                        if(Object.keys(rawData.chatInfoData.people).length > 2){
                            chatObj.roomType = 'group'
                        }

                        // Check URL Param
                        if(this.$route.query.item === chatObj.id){
                            this.openChat(chatObj, 'chat')
                            window.history.pushState('chat', 'Chat', '/chat')
                        // Check for New User Chat
                        }else if(this.$route.query.user){
                            let chatUserUid = this.$route.query.user
                            let userData = this.$store.state.allUsers[chatUserUid]

                            this.openChat(userData, 'person')
                            
                            window.history.pushState('chat', 'Chat', '/chat')        
                        }

                        chats.push(chatObj)

                        // Sort chats by lastMessageTimestamp
                        if(chats.length > 1){
                            
                            let sortedChats = chats.sort((a, b) => {
                                return moment.unix(b.lastMessageTimestamp) - moment.unix(a.lastMessageTimestamp)
                            })

                            this.chatsList = sortedChats
                        }
                    })
                }
            })
        },
        async getChatInfoData(roomId){
            let chatInfoRef = fb.rdb.ref('chats/'+ roomId + '/info')

            return chatInfoRef.once('value').then(snap => {
                let chatInfoData = snap.val()
                return chatInfoData
            }).then(async(chatInfoData) => {
                
                if(chatInfoData !== null){
                    let messages = await this.getChatMessagesData(roomId, chatInfoData.lastMessageId)
                
                    return {
                        roomId: roomId,
                        chatInfoData: chatInfoData,
                        messages: messages
                    }
                }else{
                    
                    console.log('Chat info data null: ', roomId)

                    return{
                        roomId: roomId,
                        chatInfoData: null,
                        messages: null
                    }
                }
            }).then(data => {
                return data
            })
        },
        async getChatMessagesData(roomId, lastMessageId){
            let chatLastMessageRef = fb.rdb.ref('chats/'+ roomId + '/messages').orderByKey().equalTo(lastMessageId)
            return chatLastMessageRef.once('value').then(snap => {
                return snap.val()
            })
        },
        async checkChatExists(friendId){
            let userChatRef = fb.rdb.ref('users/' + this.user.uid + '/chats/' + friendId)

            return userChatRef.once('value').then(snap => {
                let data = snap.val()
                if(data !== null){
                    console.log('Check chat room success: ', data)
                    return snap.val()
                }else{
                    console.log('Check chat room none: ', data)
                    return false
                }
            })
        },
        cleanChat(){
            // Reset data
            if(this.room.id !== null){
                if(typeof this.room.messagesRef !== 'undefined'){
                    this.room.messagesRef.off()
                    console.log('Detached messages listener!')
                }
                this.room = {
                    id: null,
                    photoURL: null,
                    title: 'Chat',
                    messages: null,
                    details: null,
                    isNew: true,
                    files: []
                }
            }
            this.createRoom.peopleObj = null

            // Files
            this.roomFiles = []
            this.filesLoading = false
            this.showImageAt = 0
            this.showLightbox = false
        },

        // Partially Done - for new openChat function
        processChat(data, type){

            console.log('Load chat: ', type, data)

            /**
             * Template
             */
            
            // this.loading = true

            let room = {
                id: null,
                title: 'Chat',
                details: null, 
                isNew: true,
                roomType: 'single',
                lastMessageTime: '',
                messages: null,
                files: null
            }

            /**
             * Map Data
             * for existing chats
             */

            if(type === 'person'){

                // 1. UserData
                // 2. Only small info

            }else if(type === 'chat'){
                
                // 1. Chat Details
                room.id = data.id
                room.title = data.name
                room.details = {
                    info: data.info,
                    peopleObj: {}
                }
                room.isNew = false
                room.roomType = data.roomType
                room.details.info.roomType = data.roomType
                room.lastMessageTime = data.lastMessage.timestamp
                room.messages = data.messages
                room.files = []

            }else if(type === 'group'){

                room.id = null
                room.title = 'Group Chat'
                room.details = {
                    info: {},
                    peopleObj: {}
                }
                room.isNew = true
                room.roomType = type
                room.details.info.roomType = type
                room.messages = []
            }

            /**
             * New Room Id 
             * for New Chats
             */

            if(room.isNew){
                let chatRef = fb.rdb.ref('chats/').push()
                room.id = chatRef.key
            }

            /**
             * Assign Room
             * Avatars & People
             */

            if(room.isNew){
                if(type === 'person'){

                    room.details.peopleObj[this.user.uid] = {
                        uid: this.user.uid,
                        displayName: this.user.name,
                        photoURL: this.user.photo
                    }
                    room.details.peopleObj[data.uid] = {
                        uid: data.uid,
                        displayName: data.displayName,
                        photoURL: data.photoURL
                    }
                }else if(type === 'group'){

                    room.details.peopleObj = this.createRoom.peopleObj
                    this.createRoom.peopleObj = null
                }
            }

            // this.loading = false
            // this.room = room

            console.log('Processed room details: ', room)
        },
        
        async openChat(data, type){

            console.log('Open chat data: ', data)
            
            this.loading = true
            
            let mainData = data
            let existingRoomId = null
            let roomId = null
            let roomType = 'single'

            // Mobile only - Toggle messages area
            if(!this.window.isDesktop){
                this.window.mobileNavItem = 'chat'
            }

            /** ======================================
             * 1. Chat Type
             * - Existing Chat
             * - Single Person Chat
             * - Group Chat
             */

            // Load existing chat
            if(type === 'chat'){

                this.cleanChat()
                
                console.log('Existing chat load: ', data)

                existingRoomId = data.id
                roomType = data.roomType

            // Create Single Chat
            }else if(type === 'person'){

                this.cleanChat()

                console.log('Check chat by user ids: ', this.$store.state.currentUser.uid, data.uid)

                let existingChat = this.$store.getters.getChatByUserIds(this.$store.state.currentUser.uid, data.uid)

                console.log('Existing chat from person type: ', existingChat)

                if(existingChat !== null){
                    this.searchInput = ''
                    this.chatsOrPeople = 'Chats'

                    data = existingChat
                    type = 'chat'

                    console.log('Changed type to data: ', data)

                    existingRoomId = existingChat.id
                    roomType = existingChat.roomType
                }else{
                    console.log('Did not find existing chat!')
                }

            // Create Group Chat
            }else if(type === 'group'){

                roomType = type

                let existingChat = this.chatsList.filter(chat => {
                    if(Object.keys(chat.info.people).length === Object.keys(data).length){
                        let matchCount = 0

                        Object.keys(chat.info.people).forEach(personKey => {
                            if(typeof(data[personKey]) !== 'undefined'){
                                matchCount += 1
                            }
                        })

                        if(matchCount === Object.keys(data).length){
                            return chat
                        }
                    }
                    return null
                })

                if(existingChat.length > 0){
                    data = existingChat[0]
                    type = 'chat'
                    existingRoomId = existingChat[0].id
                    roomType = existingChat.roomType

                    this.chatsOrPeople = 'Chats'
                    this.createRoom.peopleObj = null
                }else{
                    this.room.isNew = true
                }
            }


            /**
             * 2. Get Room Id
             * Create room id if it's a new chat room
             * - Existing chat
             * - New chat
             */
            
            // Existing
            if(existingRoomId){

                this.room.isNew = false
                roomId = existingRoomId
                
                console.log('Load existing chat room id: ', roomId)

            // New Chat Room
            }else{

                let chatRef = fb.rdb.ref('chats/').push()
                roomId = chatRef.key

                console.log('Load new chat room id: ', roomId)
            }
            
            
            /**
             * 3. Set Chat Details
             */

            if(roomId){
                this.room.id = roomId

                this.room.details = {
                    peopleObj: {},
                    info: null
                }

                // Person
                if(type === 'person'){

                    this.room.title = data.displayName
                    // this.room.photoURL = data.photoURL

                // Chat
                }else if(type === 'chat'){
                 
                    if(roomType === 'single'){
                        this.room.title = data.name
                    }else if(roomType === 'group'){
                        this.room.title = data.name
                    }

                // Group
                }else if(type === 'group'){
                    this.room.title = 'Group Chat'
                }

                if(this.room.title === 'Chat'){
                    if(type === 'chat'){
                        this.room.title = mainData.displayName
                    }
                }

                // New Room
                if(this.room.isNew){
                    if(type === 'person'){
                        this.room.details.peopleObj[this.user.uid] = {
                            uid: this.user.uid,
                            displayName: this.user.name,
                            photoURL: this.user.photo
                        }
                        this.room.details.peopleObj[data.uid] = {
                            uid: data.uid,
                            displayName: data.displayName,
                            photoURL: data.photoURL
                        }
                    }else if(type === 'group'){
                        let peopleObj = this.createRoom.peopleObj
                        this.room.details.peopleObj = peopleObj
                        this.createRoom.peopleObj = null
                    }

                    this.loading = false
                }

                console.log('Room details: ', this.room)

                /**
                 * Listen for chat messages and details
                 */

                await this.$bind('roomFiles', fb.db.collection('chats').doc(roomId).collection('files').orderBy('timestamp', 'desc'))

                console.log('Room files: ', this.roomFiles)

                let roomRef = fb.rdb.ref('chats/'+ roomId)
                let roomInfoRef = fb.rdb.ref('chats/'+ roomId + '/info')
                let roomMessagesRef = fb.rdb.ref('chats/'+ roomId + '/messages').limitToLast(10)

                roomRef.on('value', snap => {
                    let chatData = snap.val()

                    console.log('Listen for room details: ', chatData)

                    // Existing Room
                    if(chatData !== null){
                        if(typeof(chatData.info) !== 'undefined'){

                            // Info
                            this.room.details.info = chatData.info
                            this.room.details.info.roomType = roomType
                            this.room.isNew = false

                            // Room Avatars
                            if(typeof data.info !== 'undefined'){
                                if(typeof data.info.avatars !== 'undefined'){
                                    this.room.details.info.avatars = data.info.avatars
                                }
                            }

                            // Assign people
                            if(typeof(chatData.info.people) !== 'undefined'){

                                this.room.details.peopleObj = {}

                                Object.keys(chatData.info.people).forEach(key => {

                                    let personObj = {
                                        uid: this.$store.state.allUsers[key].uid,
                                        displayName: this.$store.state.allUsers[key].displayName,
                                        photoURL: this.$store.state.allUsers[key].photoURL
                                    }

                                    this.room.details.peopleObj[key] = personObj
                                })
                            }

                            // Room Type
                            if(typeof(chatData.info.roomType) !== 'undefined'){
                                this.room.roomType = chatData.info.roomType
                            }
                        }

                        // Assign Messages
                        if(typeof(chatData.messages) !== 'undefined'){
                            this.getChatMessages(chatData.messages)
                        }

                    // New Room
                    }else{
                        this.room.messages = []
                        this.room.details.info = {
                            roomType: roomType
                        }
                    }
                })
            }
        },
        getChatMessages(allMessages){

            this.room.lastMessageTime = null
            let messages = []

            Object.keys(allMessages).forEach(key => {
                let messageData = allMessages[key]
                messages.push(this.processMessage(messageData, key))
            })

            this.loading = false
            this.room.messages = messages

            this.messageAreaScroll()
        },
        processMessage(messageData, key){

            messageData.messageId = key
            messageData.displayName = this.$store.state.allUsers[messageData.uid].displayName
            messageData.photoURL = this.$store.state.allUsers[messageData.uid].photoURL
            messageData.showMessageTime = false

            // Message Time
            if(this.room.lastMessageTime === null){

                this.room.lastMessageTime = messageData.timestamp
                messageData.showMessageTime = true

            }else{
                let currentTime = moment(messageData.timestamp).local()
                let messageTime = moment(this.room.lastMessageTime).local()
                let diff = moment.duration(currentTime.diff(messageTime))
                let minutes = parseInt(diff.asMinutes())
                let days = parseInt(diff.asHours())

                if(minutes > 10){
                    this.room.lastMessageTime = messageData.timestamp
                    messageData.showMessageTime = true
                }
                if(days > 1){
                    this.room.lastMessageTime = messageData.timestamp
                    messageData.showMessageTime = true
                }
            }

            // Update last seen id
            if(this.room.details.info.lastMessageId === key){
                if(typeof(messageData.seen[this.user.uid]) === 'undefined'){

                    let lastMessageRef = fb.rdb.ref('chats/' + this.room.id + '/messages/'+ key + '/seen')
                    let seenData = messageData.seen

                    seenData[this.user.uid] = key

                    console.log('Last message status updated: ', key)

                    lastMessageRef.update(seenData)
                }
            }

            // Assign last seen id for people
            Object.keys(this.room.details.peopleObj).forEach(personKey => {
                if(typeof(messageData.seen[personKey]) !== 'undefined'){
                    this.room.details.peopleObj[personKey].lastMessageId = messageData.seen[personKey]
                }
            })

            return messageData
        },
        getChatPhotoUrls(chatItem){
            console.log('Get photo urls: ', chatItem)
            let photoUrl = []
            if(chatItem.roomType === 'single'){
                photoUrl.push(Object.keys(chatItem.peopleObj)[0].photoURL)
            }else if(chatItem.roomType === 'group'){
                Object.keys(chatItem.peopleObj).forEach(key => {
                    photoUrl.push(chatItem.peopleObj[key].photoURL)
                })
            }
            return photoURL
        },

        openChatById(chatItem){

            this.loading = true
            this.cleanChat()

            // Map Chat Data
            let chatRoomPeopleObj = {}

            Object.keys(chatItem.info.people).forEach(personUid => {
                let userData = this.$store.state.allUsers[personUid]

                chatRoomPeopleObj[personUid] = {
                    displayName: userData.displayName,
                    photoURL: userData.photoURL,
                    uid: personUid
                }
            })
 
            let chatRoomData = {
                id: chatItem.id,
                photoURL: null,
                title: chatItem.name,
                isNew: false,
                roomType: chatItem.roomType,
                details: {
                    info: chatItem.info,
                    peopleObj: chatRoomPeopleObj
                },
                messages: null,
                files: null,
            }
            chatRoomData.details.info.roomType = chatItem.roomType

            this.room = chatRoomData
            this.getChatMessages(chatItem.messages)
            this.messagesListener(this.room.id)

            // this.loading = false

            console.log('Open chat by id room data: ', this.room)
        },
        messagesListener(roomId){

            /**
             * Listen for chat messages
             */

            this.room.messagesRef = fb.rdb.ref(`chats/${roomId}`).child('messages') //.limitToLast(10)
            
            this.room.messagesRef.on('value', data => {
                if(data !== null){
                    let messages = data.val()
                    this.getChatMessages(messages)
                }
            })
        },

        // Create Chat
        toggleChat(type){
            this.chatsOrPeople = type
            this.cleanChat()
            this.searchInput = ''
        },
        createChat(){

            // Add myself if not included
            if(this.createRoom.peopleObj[this.$store.state.currentUser.uid] === null){
                this.createRoom.peopleObj[this.$store.state.currentUser.uid] = {
                    uid: this.$store.state.currentUser.uid,
                    displayName: this.$store.state.currentUser.displayName,
                    photoUrl: this.$store.state.currentUser.profileURL
                }
            }
            
            // Create single person room
            if(Object.keys(this.createRoom.peopleObj).length < 3){

                let userData = {}
                
                Object.keys(this.createRoom.peopleObj).forEach(uid => {
                    if(this.user.uid !== uid){
                        userData = this.createRoom.peopleObj[uid]
                    }
                })

                this.openChat(userData, 'person')
            
            // Create group room
            }else{
                this.openChat(this.createRoom.peopleObj, 'group')
            }

            this.chatsOrPeople = 'Chats'
            this.createRoom.peopleObj = null
            this.setRoomTitle()
        },
        createGroupChat(){
            
            if(!this.room.isNew){

                let people = this.room.details.info.people
                
                this.toggleChat('Create')

                this.createRoom.peopleObj = {}

                Object.keys(people).forEach(uid => {
                    let user = this.$store.state.allUsers[uid]

                    let userItem = {
                        uid: uid,
                        displayName: user.displayName,
                        photoURL: user.photoURL
                    }

                    this.createRoom.peopleObj[uid] = userItem
                })

                this.createRoom.peopleObj[this.$store.state.currentUser.uid].isAdmin = true

                this.createKey += 1
            
            }else{
                let people = this.room.details.peopleObj

                this.toggleChat('Create')

                this.createRoom.peopleObj = people

                this.createKey += 1
            }

            this.setRoomTitle()
        },
        selectPerson(user, type){

            // Existing Room
            if(type === 'chatRoom'){

                console.log('Room info: ', this.room)

                if(this.room.isNew){
                    this.room.details.peopleObj[user.uid] = {
                        uid: user.uid,
                        displayName: user.displayName,
                        photoURL: user.photoURL
                    }
                    this.setRoomTitle()
                }else{
                    let userObj = {}
                    userObj[user.uid] = true

                    fb.rdb.ref('chats/'+ this.room.id + '/info/people').update(userObj)
                    fb.rdb.ref('users/' + user.uid + '/chats/'+ this.room.id).update({
                        active: true
                    })
                }

            // New room
            }else{
                // Add User
                if(this.createRoom.peopleObj === null){
                    this.createRoom.peopleObj = {}
                    this.createRoom.peopleObj[this.user.uid] = {
                        uid: this.user.uid,
                        displayName: this.user.name,
                        photoURL: this.user.photo
                    }
                }

                // Add Other User
                this.createRoom.peopleObj[user.uid] = {
                    uid: user.uid,
                    displayName: user.displayName,
                    photoURL: user.photoURL
                }

                this.createKey += 1
            }

            this.searchPeople = ''
            this.searchInput = ''
            this.setRoomTitle()
        },
        removePerson(userUid, type){

            let name = this.$store.state.allUsers[userUid].firstName
            let msg = 'Are you sure you want to remove '+ name +' from chat?'
            if(userUid === this.user.uid){
                msg = 'Are you sure you want to leave this chat room?'
            }

            if(this.room.isNew){

                if(confirm(msg)){
                    if(this.createRoom.peopleObj !== null){
                        console.log('Remove user from createRoom: ', userUid)
                        
                        delete this.createRoom.peopleObj[userUid]
                        
                        // Remove myself if exists
                        if(Object.keys(this.createRoom.peopleObj).length === 1){
                            if(typeof this.createRoom.peopleObj[this.$store.state.currentUser.uid] !== 'undefined'){
                                delete this.createRoom.peopleObj[this.$store.state.currentUser.uid]
                                this.createRoom.peopleObj = null
                            }
                        }

                        this.createKey += 1
                    }

                    if(this.room.details !== null){
                        if(this.room.details.peopleObj !== null){
                            console.log('Remove user from room details: ', userUid)

                            let newRoomPeople = this.room.details.peopleObj
                            delete newRoomPeople[userUid]

                            this.room.details.peopleObj = newRoomPeople
                        }
                    }

                    console.log('Remove user room info: ', this.room)
                    this.setRoomTitle()
                }

            }else{
                if(confirm(msg)){
                    console.log('Remove this user from room: ', userUid, this.room.roomType)

                    if(Object.keys(this.room.details.peopleObj).length > 2){
                        fb.rdb.ref('chats/'+ this.room.id + '/info/people/'+ userUid).remove()
                        fb.rdb.ref('users/' + userUid + '/chats/'+ this.room.id).remove()
                    }else{
                        alert('Archive this room, only one person left!')
                    }

                    this.setRoomTitle()
                }
            }
        },
        checkIfUserSelected(user){
            if(this.createRoom.peopleObj !== null){
                if(typeof this.createRoom.peopleObj[user.uid] !== 'undefined'){
                    return true
                }
            }
            return false
        },
        setRoomTitle(){
            if(this.room.isNew){
                if(this.room.details !== null){
                    if(this.room.details.peopleObj !== null){
                        if(Object.keys(this.room.details.peopleObj).length > 2){
                            let roomTitle = ''

                            Object.keys(this.room.details.peopleObj).forEach(personKey => {
                                if(this.$store.state.currentUser.uid !== personKey){
                                    if(roomTitle !== '') roomTitle += ', '
                                    roomTitle += this.$store.state.allUsers[personKey].firstName
                                }
                            })

                            this.room.title = roomTitle
                        }
                    }
                }
            }
        },

        // Chat Details Logic
        toggleAddPerson(){
            this.addPersonActive = !this.addPersonActive
            this.searchInput = ''
        },
        deleteChat(){
            if(confirm('Are you sure you want to permanently delete this conversation?')){
                
                let chatUpdateData = {
                    active: false
                }
                fb.rdb.ref('users/'+ this.user.uid + '/chats/'+ this.room.id).update(chatUpdateData)

                this.cleanChat()
            }
        },

        // Input Handlers
        gifSelected(url){

            this.showGifPicker = false
            this.messageInput = ':gif:'

            this.sendMessage({
                type: 'gif',
                url: url
            })
        },
        stickerSelected(url){

            this.showStickerPicker = false
            this.messageInput = ':sticker:'

            this.sendMessage({
                type: 'sticker',
                url: url
            })
        },
        triggerUploadFile(e){
            this.$refs.fileUploadInput.click()
        },

        // Message Actions
        sendMessage(data){
            if(this.messageInput === null || this.messageInput === '') return

            // Message Ref
            let roomInfoRef = fb.rdb.ref('chats/'+ this.room.id + '/info')
            let roomMessagesRef = fb.rdb.ref('chats/'+ this.room.id + '/messages').push()
            let messageId = roomMessagesRef.key

            // Message Type
            let messageType = 'text'

            // Check for emoji
            if(this.messageInput.indexOf('onemgl-') !== -1){
                messageType = 'custom-emoji'
            }
            if(this.hasEmoji(this.messageInput)){
                messageType = 'system-emoji'
            }

            // Message Data
            let messageData = {
                uid: this.user.uid,
                message: this.messageInput,
                timestamp: fb.firebase.database.ServerValue.TIMESTAMP,
                type: messageType,
                seen: {}
            }
            
            // Other Types of Messages
            if(data){
                if(data.type === 'gif'){
                    messageData.type = 'gif'
                    messageData.url = data.url
                }else if(data.type === 'sticker'){
                    messageData.type = 'sticker'
                    messageData.url = data.url
                }else if(data.type === 'image-single'){

                    messageData.type = 'image-single'
                    messageData.urls = data.urls
                    messageData.total = 1

                    this.room.files = []

                }else if(data.type === 'image-multiple'){

                    messageData.type = 'image-multiple'
                    messageData.urls = data.urls
                    messageData.total = data.urls.length

                    this.room.files = []
                }
            }

            // Set user seen lastMessageId
            messageData.seen[this.user.uid] = messageId

            // Info Data
            let infoData = {
                lastMessageId: messageId
            }

            // New room
            if(this.room.isNew){

                // Default stuff
                infoData.createdOn = messageData.timestamp

                // People
                infoData.people = {}

                // Admin
                infoData.admin = {}
                infoData.admin[this.user.uid] = true

                Object.keys(this.room.details.peopleObj).forEach(personKey => {

                    infoData.people[this.room.details.peopleObj[personKey].uid] = true

                    // Add roomId to everyone's room ref
                    fb.rdb.ref('users/' + this.room.details.peopleObj[personKey].uid + '/chats/'+ this.room.id).update({
                        active: true
                    })
                })
            }

            // Update db
            roomInfoRef.update(infoData)
            roomMessagesRef.set(messageData)

            // Set Activity
            this.sendMessageNotification(messageData)

            this.messageInput = ''

            // if(this.room.isNew){
            //     this.getAllChats()
            // }
        },
        async deleteMessage(index){

            if(confirm('Are you sure you want to delete this message?')){

                let roomInfoRef = fb.rdb.ref('chats/'+ this.room.id + '/info')
                let messageData = this.room.messages[index]
                let roomMessageRef = fb.rdb.ref('chats/'+ this.room.id + '/messages/'+ messageData.messageId)

                if(messageData.type === 'image-single' || messageData.type === 'image-multiple'){
                    
                    for(let i = 0; i < messageData.urls.length; i++){
                        await this.deleteFileFromStorage(messageData.urls[i].name)
                    }
                }

                this.room.messages[index].type = 'deleted'

                roomMessageRef.update({
                    type: 'deleted'
                })
            }
        },
        async deleteFileFromStorage(fileName){

            let roomId = this.room.id
            let fileRef = fb.storage.ref().child(`chatFiles/${roomId}/${fileName}`)

            return await fileRef.delete().then(() => {
                console.log('Successfully deleted file with name: ', fileName)
                return true
            }).catch(error => {
                console.log('Error deleting file: ', error.message)
                return null
            })
        },
        likeMessage(message, type){

            let roomMessageRef = fb.rdb.ref(`chats/${this.room.id}/messages/${message.messageId}/reactions`)

            let reactions = {
                likes: {}
            }

            if(typeof message.reactions !== 'undefined'){
                reactions = message.reactions
            }
            if(type === 'like'){
                reactions.likes[this.user.uid] = true
            }

            roomMessageRef.update(reactions)
        },
        copyMessage(message){
            
            navigator.clipboard.writeText(message.message).then(() => {

                this.$notify({
                    group: 'globalNotifications',
                    title: 'Successful',
                    text: 'Message copied to clipboard.'
                })
                
            }, (err) => {

                this.$notify({
                    group: 'globalNotifications',
                    title: 'Error',
                    text: 'Oops, something went wrong.'
                })
            })
        },
        forwardMessage(message){

            console.log('Forward message: ', message)

        },
        toggleEmojiPicker(){
            this.showGifPicker = false
            this.showStickerPicker = false
            this.showEmojiPicker = !this.showEmojiPicker
        },
        toggleGifPicker(){
            this.showEmojiPicker = false
            this.showStickerPicker = false
            this.showGifPicker = !this.showGifPicker
        },
        toggleStickerPicker(){
            this.showEmojiPicker = false
            this.showGifPicker = false
            this.showStickerPicker = !this.showStickerPicker
        },
        hidePicker(e){
            console.log('Picker hide: ', e)
            this.showEmojiPicker = false
        },
        selectEmoji(emoji){
            this.messageInput += emoji.native
        },
        hasEmoji(text){
            let emoji_regex = /^(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])+$/
            return emoji_regex.test(text)
        },

        // New File Upload
        addFiles(e){
            let droppedFiles = e.dataTransfer.files
            if(!droppedFiles) return
            
            this.dragAreaActive = false
            this.filesLoading = true
            this.$refs.fileUpload.addFilesToPond(droppedFiles)
        },
        addFilesFromInput(e){
            let droppedFiles = e.target.files
            if(!droppedFiles) return

            this.dragAreaActive = false
            this.filesLoading = true
            this.$refs.fileUpload.addFilesToPond(droppedFiles)
        },
        syncAllUploadedFiles(files){

            console.log('Finished uploading and generating all files: ', files)
 
            let preparedFiles = []

            for(let i = 0; i < files.length; i++){
                let file = files[i]

                if(file.type === 'image'){
                    preparedFiles.push({
                        id: file.id,
                        type: file.type,
                        uid: file.uid,
                        userUid: file.userUid,
                        medium: {
                            url: file.medium.url
                        },
                        original: {
                            url: file.original.url
                        },
                        small: {
                            url: file.small.url
                        },
                        tiny: {
                            url: file.tiny.url
                        }
                    })
                }else if(file.type === 'video'){
                    preparedFiles.push({
                        id: file.id,
                        type: file.type,
                        fileType: file.fileType,
                        uid: file.uid,
                        userUid: file.userUid,
                        poster: {
                            url: file.poster.url
                        },
                        url: file.url
                    })
                }
            }

            if(files.length > 0){
                this.messageInput = ':images:'
                let type = preparedFiles.length > 1 ? 'image-multiple' : 'image-single'

                this.sendMessage({
                    type: type,
                    urls: preparedFiles
                })

                console.log('All files uploaded and sent as a message: ', files)
            }

            this.fileUploaderKey += 1
            this.filesLoading = false
        },
        removedFile(fileId){
            let newFiles = this.room.files.filter(file => {
                return file.id !== fileId
            })
            this.room.files = newFiles
        },
        dragOver(){
            this.dragAreaActive = true
        },
        dragLeave(){
            this.dragAreaActive = false
        },
        showLightBoxItemById(id){

            console.log('Show lightbox with file id: ', id)

            const isFileIndex = (element) => element.id === id
            let fileIndex = this.roomFiles.findIndex(isFileIndex)

            // console.log('Found file with index: ', fileIndex)

            this.showImageAt = fileIndex
            this.showLightBox = true
        },

        // Old File Uploader
        async prepareFilesForUpload(droppedFiles){
            this.dragAreaActive = false
            this.room.files = droppedFiles

            let allFilesData = []

            for(let i = 0; i < this.room.files.length; i++){
                this.room.files[i].progress = 0
                let fileData = await this.uploadFile(this.room.files[i], i)
                allFilesData.push(fileData)
            }

            if(allFilesData.length > 0){
                this.messageInput = ':images:'
                let type = allFilesData.length > 1 ? 'image-multiple' : 'image-single'

                this.sendMessage({
                    type: type,
                    urls: allFilesData
                })

                console.log('All files uploaded and sent as a message: ', allFilesData)
            }
        },
        async uploadFile(file, index){

            let userUid = this.user.uid
            let roomId = this.room.id
            
            let fileOldName = file.name
            let fileExt = this.getFileExtension(file)
            let fileName = fileExt.name
            let fileSize = this.getFileSize(file, 'mb')
            let fileType = file.type
            let fileMsgType = 'image'

            let fileRef = fb.storage.ref().child(`chatFiles/${roomId}/${fileName}`).put(file)

            console.log('Upload file type: ', fileType)

            if(fileType === 'video/mp4'){
                fileMsgType = 'video'
            }

            fileRef.on('state_changed', snapshot => {
                let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                this.room.files[index].progress = progress
            })

            return await fileRef.then(snapshot => {
                return snapshot.ref.getDownloadURL().then(url => {

                    let fileData = {
                        url: url,
                        name: fileName,
                        uid: userUid,
                        timestamp: fb.firebase.database.ServerValue.TIMESTAMP,
                        type: fileMsgType
                    }

                    return fileData

                }).catch(err => {
                    this.handleUploadError(err, 'Get download url error!')
                    return null
                })
            }).catch(err => {
                this.handleUploadError(err, 'Put error!')
                return null
            })
        },
        handleUploadError(error, msg){
            console.log('Uploader error: ', error.message, msg)
        },

        // Reactions
        getMessageReactionsHint(messageReactions){

            let hint = ''

            Object.keys(messageReactions).forEach(reaction => {
                let emoji = ''
                if(reaction === 'likes'){
                    emoji = '<ion-icon name="thumbs-up"></ion-icon>'
                }
                Object.keys(messageReactions[reaction]).forEach(uid => {
                    let hintRow = `<span class="emoji">${emoji}</span>${this.$store.state.allUsers[uid].displayName}`
                    hint += hintRow + '<br>'
                })
            })

            return hint
        },

        // Notifications
        sendNotification(title, message, duration){
            
            // In App Notification
            this.$notify({
                group: 'globalNotifications',
                title: title,
                text: message,
                duration: duration,
                position: 'bottom left'
            })

            // Native Notification
            this.$notification.show(title, {
                body: message
            }, {})
        },
        async addNewActivity(messageData, receiverId){

            let userNotificationRef = fb.db.collection('users').doc(receiverId).collection('notifications')
            let path = `/chat?item=${this.room.id}`
            let type = 'chat'
            let senderId = messageData.uid

            let newActivity = {
                timestamp: fb.firebase.firestore.FieldValue.serverTimestamp(),
                uid: senderId,
                message: messageData.message,
                path: path,
                to: receiverId,
                type: type,
                itemId: this.room.id,
                seen: false
            }

            await userNotificationRef.add(newActivity).then(doc => {
                console.log('New activity created with id: ', doc.id)
            }).catch(err => {
                console.log('Error creating new activity: ', err)
            })
        },
        sendMessageNotification(messageData){
            Object.keys(this.room.details.peopleObj).forEach(async(personKey) => {
                if(personKey === this.user.uid) return

                console.log('Send message notification to: ', personKey)

                await this.addNewActivity(messageData, personKey)

                // if(typeof this.$store.getters.getAllOnlineUsers[personKey] === 'undefined'){
                        
                // }
                // else{
                //     console.log(this.$store.getters.getAllOnlineUsers[personKey].displayName + ' is already online, sending an in app notification!')
                // }
            })
        },

        // Utils
        handleScroll(e){
            if(this.$refs.messageScrollArea.scrollTop >= this.$refs.messageScrollArea.scrollHeight - this.$refs.messageScrollArea.clientHeight){
                this.showScrollToBottom = false
            }else{
                this.showScrollToBottom = true
            }
        },
        messageAreaScroll(){
            if(this.room.messages === null) return
            if(typeof(this.$refs.messageScrollArea) === 'undefined') return
            
            setTimeout(() => {
                this.$refs.messageScrollArea.scroll({
                    top: this.$refs.messageScrollArea.scrollHeight,
                    left: 0,
                    behavior: 'smooth'
                })

                this.$refs.messageInput.focus()
            }, 500)
        },
        isChatActive(userData){
            let isActive = false

            if(this.user.uid !== userData.uid){
                if(this.room.details !== null){
                    if(this.room.details.peopleObj !== null){
                        
                        Object.keys(this.room.details.peopleObj).forEach(personKey => {
                            if(this.room.details.peopleObj[personKey].uid !== this.user.uid && this.room.details.peopleObj[personKey].uid === userData.uid){
                                isActive = true
                            }
                        })
                    }
                }
            }

            return isActive
        },
        getFileExtension(file){
            let fileExt = (file.name).split('').reverse().join('')
            fileExt = fileExt.split('.')[0]
            fileExt = fileExt.split('').reverse().join('')
            let fileName = (file.name).split('.'+ fileExt)[0]
            fileName = fileName + '-' + new Date().getTime() + '.' + fileExt

            return {
                name: fileName,
                ext: fileExt
            }
        },
        getFileSize(file, type){
            if(type === 'mb'){
                return file.size / 1024 / 1024
            }else if(type === 'kb'){
                return file.size / 1024
            }
        },
        setWindowSize(){
            // Desktop
            let headerHeight = 91
            let mobileNavHeight = 40
            let isDesktop = false

            if(window.innerWidth > 1023){
                mobileNavHeight = 0
                isDesktop = true
            }

            this.window.height = window.innerHeight - headerHeight - mobileNavHeight
            this.window.isDesktop = isDesktop
        },

        // Helper Checks
        userHasLocation(member){
            if(typeof member.location !== 'undefined' && member.location !== null){
                if(typeof member.location.city !== 'undefined' && member.location.city !== null){
                    return true
                }
            }
            return false
        },
        hasReactions(message){
            if(typeof(message.reactions) !== 'undefined' && message.reactions !== null){
                return true
            }
            return false
        },
        hasReactionLikes(message){
            if(typeof(message.reactions.likes) !== 'undefined' && message.reactions.likes !== null){
                return true
            }
            return false
        },
        isRoomAdmin(person){
            if(typeof this.room.details !== 'undefined' && this.room.details !== null){
                if(typeof this.room.details.info !== 'undefined' && this.room.details.info !== null){
                    if(typeof this.room.details.info.admin !== 'undefined' && this.room.details.info.admin !== null){
                        if(typeof this.room.details.info.admin[person.uid] !== 'undefined'){
                            return true
                        }
                    }
                }
            }
            return false
        }
    },
    
    filters: {
        messageTime(value){
            let currentTimestamp = moment()
            let lastMessageUserTimestamp = moment(value).local()
            let diff = moment.duration(currentTimestamp.diff(lastMessageUserTimestamp))
            let lastMessageTime = lastMessageUserTimestamp.format('MMM D, h:mm a')

            if(diff.asDays() <= 7){
                lastMessageTime = lastMessageUserTimestamp.format('ddd, h:mm a')
            }
            if(diff.asHours() <= 24){
                lastMessageTime = lastMessageUserTimestamp.format('h:mm a')
            }

            return lastMessageTime.toUpperCase()
        },
        createdOn(value){
            return moment(value).local().format('MMM D, YYYY - h:mm a')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/Chat.vue